import { CancelOutlined, CheckBox } from "@mui/icons-material";
import { Suspense, lazy, useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import LoadingFallback from "../../../components/LoadingFallback";
import { Button } from "@mui/material";
import { green, red } from "@mui/material/colors";

// Same modals the drilldown status selector opens — one implementation, two
// entry points.
const MarkLoanClosedModal = lazy(() => import("../modals/MarkLoanClosedModal"));
const MarkLoanDeadModal = lazy(() => import("../modals/MarkLoanDeadModal"));

/**
 * Types: "Closed", "Dead"
 */
const LoanDrilldownButtonMarkLoan = ({ type }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const [show, setShow] = useState(false);

  const isClosedOrDead = useMemo(() => {
    if (type === "Closed") {
      if (
        loanDrilldown?.loanStatus === "Closed" ||
        loanDrilldown?.loanStatus === "Closed w/ Post Closing Conditions"
      ) {
        return true;
      }
    }
    if (type === "Dead") {
      if (loanDrilldown?.loanStatus === "Dead") {
        return true;
      }
    }
    return false;
  }, [loanDrilldown, type]);

  const isDisabled = useMemo(() => {
    if (type === "Dead") {
      if (
        loanDrilldown?.loanStatus === "Closed" ||
        loanDrilldown?.loanStatus === "Closed w/ Post Closing Conditions"
      ) {
        return true;
      }
    }
    if (type === "Closed") {
      if (loanDrilldown?.loanStatus === "Dead") {
        return true;
      }
    }

    return false;
  }, [loanDrilldown?.loanStatus, type]);

  const color = useMemo(() => {
    if (type === "Closed") {
      return "success";
    }
    if (type === "Dead") {
      return "error";
    }
    if (isClosedOrDead) {
      if (type === "Closed") {
        return "success";
      }
      if (type === "Dead") {
        return "error";
      }
    }

    return "primary";
  }, [isClosedOrDead, type]);

  const icon = useMemo(() => {
    if (isClosedOrDead) {
      if (type === "Closed") {
        return <CheckBox fontSize="small" />;
      }
      if (type === "Dead") {
        return <CancelOutlined fontSize="small" />;
      }
    }

    return null;
  }, [isClosedOrDead, type]);

  const buttonText = useMemo(() => {
    if (type === "Closed") {
      return isClosedOrDead ? "Loan Marked As Closed" : "Mark Loan Closed";
    }
    if (type === "Dead") {
      return isClosedOrDead ? "Loan Marked As Dead" : "Mark Loan Dead";
    }
  }, [type, isClosedOrDead]);

  const styles = useMemo(() => {
    if (isClosedOrDead) {
      if (type === "Closed") {
        return {
          background: green[50],
        };
      }
      if (type === "Dead") {
        return {
          background: red[50],
        };
      }
    }
  }, [type, isClosedOrDead]);

  const onClick = useCallback(() => {
    if (isClosedOrDead) {
      return;
    }
    setShow(true);
  }, [isClosedOrDead]);

  if (type !== "Closed" && type !== "Dead") {
    return null;
  }
  // Only show if admin
  return (
    <Suspense fallback={<LoadingFallback />}>
      {show && type === "Closed" && (
        <MarkLoanClosedModal onClose={() => setShow(false)} />
      )}
      {show && type === "Dead" && (
        <MarkLoanDeadModal onClose={() => setShow(false)} />
      )}

      <Button
        // size="medium"
        // size="large"
        sx={styles}
        disabled={isDisabled}
        color={color}
        onClick={onClick}
        startIcon={icon}
        // variant={"text"}
        variant={isClosedOrDead ? "text" : "contained"}
      >
        {buttonText}
      </Button>
    </Suspense>
  );
};

export default LoanDrilldownButtonMarkLoan;
